import { first, get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { assetQuery, matrixBlockQuery } from '../../content/query-snippets';
import { CardListing } from '../card-listing';
import { cmsImagePropTypes } from '../../prop-types';
import { Container, Flex } from '../grid';
import { FeatureCard } from '../card';
import { BlockHeader } from '../block-header';

const columns = {
  '2': {
    cardWidth: { xs: 12 / 12, md: 6 / 12 },
  },
  '3': {
    cardWidth: { xs: 12 / 12, md: 4 / 12 },
  },
};

const FeatureCardBlock = ({ heading, viBody, featureCardItems, cardsPerRow, ...rest }) => {
  const transformedFeatureCardItems = featureCardItems.map(featureCardItem => {
    const cardLink = get(first(featureCardItem.internalLink), 'uri');
    return {
      ...featureCardItem,
      internalLink: [{ uri: cardLink ? `/${cardLink}` : null }],
    };
  });

  return (
    <Container variant="featuredContent" my={{ xs: '64px', lg: '120px' }} {...rest}>
      <BlockHeader heading={heading} body={viBody} />
      {!isEmpty(featureCardItems) && (
        <Flex justifyContent="center">
          <CardListing
            cardAlignment={transformedFeatureCardItems.length > cardsPerRow ? 'flex-start' : 'center'}
            body={viBody}
            CardComponent={FeatureCard}
            cardWidth={columns?.[cardsPerRow]?.cardWidth || columns['3'].cardWidth}
            cardGapX={{ xs: '12px', md: '16px' }}
            cardGapY={{ xs: '24px 0', md: '32px 0' }}
            gutter={{ xs: '-12px', md: '-16px' }}
            width={cardsPerRow === '2' && { xs: 1, md: 8 / 12 }}
            heading={heading}
            imageTransformIsRequired
            items={transformedFeatureCardItems}
          />
        </Flex>
      )}
    </Container>
  );
};

FeatureCardBlock.propTypes = {
  viBody: PropTypes.string,
  heading: PropTypes.string,
  featureCardItems: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      heading: PropTypes.string,
      image: PropTypes.arrayOf(cmsImagePropTypes),
    })
  ).isRequired,
  cardsPerRow: PropTypes.string,
};

FeatureCardBlock.defaultProps = {
  viBody: null,
  cardsPerRow: '3',
  heading: null,
};

FeatureCardBlock.query = `
  ... on contentMatrix_featureCardBlock_BlockType {
    featureCardItems {
      ... on featureCardItems_Entry {
        ${assetQuery('image')}
        slug
        title
        heading
        description
        internalLink {
          uri
        }
      }
    }
    ${matrixBlockQuery}
    viBody
    cardsPerRow
    heading
  }
`;

export { FeatureCardBlock };
